<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Empty layout -->
<!-- ----------------------------------------------------------------------------------------------------- -->
@if (layout === 'empty') {
    <empty-layout></empty-layout>
}

<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Layouts with horizontal navigation -->
<!-- ----------------------------------------------------------------------------------------------------- -->

<!-- Centered -->
@if (layout === 'centered') {
    <centered-layout [showClinicNow]="showClinicNow"></centered-layout>
}

<!-- Enterprise -->
@if (layout === 'enterprise') {
    <enterprise-layout [showClinicNow]="showClinicNow"></enterprise-layout>
}

<!-- Material -->
@if (layout === 'material') {
    <material-layout [showClinicNow]="showClinicNow"></material-layout>
}

<!-- Modern -->
@if (layout === 'modern') {
    <modern-layout [showClinicNow]="showClinicNow"></modern-layout>
}

<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Layouts with vertical navigation -->
<!-- ----------------------------------------------------------------------------------------------------- -->

<!-- Classic -->
@if (layout === 'classic') {
    <classic-layout [showClinicNow]="showClinicNow"></classic-layout>
}

<!-- Classy -->
@if (layout === 'classy') {
    <classy-layout [showClinicNow]="showClinicNow"></classy-layout>
}

<!-- Compact -->
@if (layout === 'compact') {
    <compact-layout [showClinicNow]="showClinicNow"></compact-layout>
}

<!-- Dense -->
@if (layout === 'dense') {
    <dense-layout [showClinicNow]="showClinicNow"></dense-layout>
}

<!-- Futuristic -->
@if (layout === 'futuristic') {
    <futuristic-layout [showClinicNow]="showClinicNow"></futuristic-layout>
}

<!-- Thin -->
@if (layout === 'thin') {
    <thin-layout [showClinicNow]="showClinicNow"></thin-layout>
}

<!-- <settings></settings> -->

